import api from './client'

// Avisos "cuando vuelva" de la tienda: demanda de productos agotados.
export const avisosStockApi = {
  masEsperados: () => api.get('/avisos-stock/mas-esperados'),
}
